import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { callQueryapi } from "../../services/http/callapi";
import { useNavigate } from "react-router-dom";
import {
  PAYVIAVOUCHER_RECHARGE,
  VALIDATE_TRANSFER,
} from "../../services/common/endpoints";
import { useTranslation } from "react-i18next";
import {
  CONST_REGEX_MOBILE,
  SELECTED_LANG,
} from "../../services/common/Constants";
import i18n from "../../helpers/i18n";
import {
  RecordScreenEvent,
  RecordlogEvents,
} from "../../../src/analytics/RecordEvents";
import { getItemOfSessionStorage } from "../../services/common/utils";
import Loadingcomponent from "../../components/loader/loadingcomponent";
import { useSelector } from "react-redux";
import { regexNumberTest } from "../../services/common/CommonUtils";
import MessageModal from "../../components/common/bottom-modal-message";
const TransferCreditPay = () => {
  //translation
  const { t } = useTranslation();

  //states
  const [errorMessage, setErrorMessage] = useState("");
  const [amountMessage, setAmountMessage] = useState("");
  const [error, seterror] = useState();
  const [continueDisabled, setContinueDisabled] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const toggleModal = () => {
    setMessageModal(!messageModal);
  };
  console.log(error, continueDisabled, "error")
  const [numbers, setNumbers] = useState({
    msisdn: "",
    amount: "",
  });

  //selectors
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const userdata = useSelector(
    (state) => state?.userdata?.value?.rnuserdetails
  );

  //navigate
  const navigate = useNavigate();
  // const x = localStorage.getItem("lang")
  const x = getItemOfSessionStorage(SELECTED_LANG);

  //effects
  useEffect(() => {
    i18n.changeLanguage(x);
    try {
      RecordScreenEvent("payviavoucher", logintype, userdata);
    } catch (e) { }
  }, []);

  useEffect(() => {
    console.log("first");
    if (error == "" && amountMessage === "") {
      setContinueDisabled(true);
    } else {
      setContinueDisabled(false);
    }
  }, []);

  //functions

  //change handler for msisdn
  const ChangeHandler = (e) => {
//     e.target.value = e.target.value.slice(0, 8);
// console.log(e.target.value.match(/^[0-9]*$/), "mathhhhhh")
//     if (e.target.value.includes(" ")) {
//       setNumbers({ ...numbers, msisdn: e.target.value });
//     } else {
//       //Check for the Name TextInput
//       setNumbers({ ...numbers, msisdn: e.target.value });
//       if (!e.target.value.trim()) {
//         seterror(t("peavmn"));
//         return;
//       } else {
//         if (e.target.value.length < 8) {
//           seterror(t("peavmn"));
//           return;
//         }
//         seterror("");
//       }
//       seterror("");
//       seterror("");
//     }
if(e?.target?.value?.length == 0) {
  seterror(t("peavmn"));
}

if (e?.target?.value?.match(/^[0-9]*$/)) {
  setNumbers({ ...numbers, msisdn: e.target.value });
}

if(e?.target?.value?.length > 8 || e?.target?.value?.length < 8 ) {
  seterror(t("peavmn"));
} 
  else 
  seterror("");
  };
  const clearMsisdn = () => {
    setNumbers({ ...numbers, msisdn: '' });
  };

  //change handler for amount and validation
  const validateAmountTextInput = (e) => {
    //Check for the Name TextInput
    seterror("");
    // if (value.length === 0) {
    //   setErrorAmountMsg(t('pea'));
    //   return;
    // } else if (value?.length > 0) {
    let regexVal = regexNumberTest(e.target.value);
    try {
      if (parseFloat(regexVal) <= 0) {
        setAmountMessage(t("pea"));
        return;
      }
      else {
        setAmountMessage("");
      }
    } catch (e) { }
    setNumbers({ ...numbers, amount: regexVal });
    // }
  };

  //record log event needed to be changed
  const CTEvent = (amount, msisdn, status) => {
    try {
      RecordlogEvents("PayViaVoucher", {
        ServiceType: "Recharge",
        "Mobile Number": userdata?.msisdn,
        "Payment Type": "Voucher",
        "Payment Amount": amount,
        "Paid Mobile Number": msisdn,
        PaymentDetails: amount,
        Status: status,
        Channel: "WEBPORTAL",
        "Login Type": logintype,
      });
    } catch (e) { }
  };

  // query call
  const validateTransfer = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [
          "_VALIDATE_TRANSFER",
          VALIDATE_TRANSFER,
          {
            msisdn_b: `965${req?.mobileNo}`,
            amount: req?.amountVal,
            civilid: "",
          },
        ],
      }),
    {
      onSuccess: (udata, variables, context) => {
        // consoleLog('udata==', JSON.stringify(udata));
        setContinueDisabled(false);
        if (udata != null && udata != undefined && udata.data != null) {
          if (udata?.data?.status === "0") {
            //set navigatgion
            console.log(udata?.data, "usdatae");
            navigate("/transfer-credit-review", {
              state: { mobileNo: numbers.msisdn, amount: numbers.amount },
            });
          } else {
            setMessageModal(true);
            setErrorMessage(udata?.data?.message);
            setContinueDisabled(false);
          }
        }
      },
      onError: (uerror, variables, context) => {
        setContinueDisabled(false);
      },
    }
  );

  // final continue click call
  const submitVoucher = () => {
    if (numbers.msisdn.length === 0) {
      seterror(t("pemn"));
    } else if (error.length > 0) {
      seterror(t("peavmn"));
    } else if (numbers.amount.length === 0) {
      setAmountMessage(t("pea"));
    } else {
      setContinueDisabled(true);
      seterror("");
      setAmountMessage("");
      validateTransfer.mutate({
        mobileNo: numbers.msisdn,
        amountVal: numbers.amount,
      });
    }
  };
  return (
    <div className="pse_sm  pt-4 pb-4">
      <div class="form-group mb-4">
        <label class="control-label">{t("rmn")}</label>
        <div class="input_icon right-icon">
          <input
            type="text"
            pattern="\\d*"
            name="msisdn"   
             onKeyDown={(evt) =>
              (evt.key === "e" || evt.key === ".") &&
              evt.preventDefault()
            }
            maxLength={8}
            onChange={(e) => {
              ChangeHandler(e);
            }}
            value={numbers.msisdn}
            class="form-control"
          // placeholder={t("rmn")}
          />
          {numbers.msisdn.length > 0 && <button onClick={clearMsisdn}><img style={{ width: '25px' }} src={process.env.PUBLIC_URL + '/assets/images/close_icon_filled.svg'} alt="" title="" /> </button>}
        </div>
        {error && <p className="text-danger">{error}</p>}
      </div>

      <div class="form-group mb-4">
        <label class="control-label">{t("Amount")}</label>
        {/* <div class="input_icon right-icon"> */}
        <div className="input_icon left-icon">
          <input
            type="text"
            maxlength="6"
            name="amount"
            onChange={(e) => {
              validateAmountTextInput(e);
            }}
            value={numbers.amount}
            autocomplete="off"
            class="form-control"
          // placeholder={t("kd")}
          />
          <button>{t("kd")}</button>
        </div>
        {/* </div> */}
        {amountMessage && <p className="text-danger">{amountMessage}</p>}
      </div>
      {/* {errorMessage && <p className="text-danger">{errorMessage}</p>} */}
      <button
        className={`custom_btn custom_btn_primary btn_block ${(continueDisabled || validateTransfer?.isLoading) && "disabled"
          }`}
        onClick={
          continueDisabled || validateTransfer?.isLoading
            ? () => { }
            : submitVoucher
        }
        disabled={continueDisabled}
      >
        {validateTransfer?.isLoading ? (
          <Loadingcomponent message={"Loading"} />
        ) : (
          t("continue")
        )}
      </button>
      <MessageModal
        show={messageModal}
        message={errorMessage}
        type="6"
        toggleModal={toggleModal}
        handleOk={toggleModal}
      />
    </div>
  );
};
export default TransferCreditPay;
